import * as types from './types';

const initialState = {
  id: undefined,
  posting: {},
  loading: 'loading',
  isPosting: false,
  imageSizes: { mobile: '94x94', tablet: '360x266', desktop: '274x125' }
};

const PostingFilteredReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_POSTING:
      state.loading = 'loading';
      state.id = action.payload;
      state.isPosting = true;
      return { ...state };
    case types.FETCH_POSTING_SUCCEEDED:
      state.posting = action.payload;
      state.loading = 'loaded';
      return { ...state };
    case types.FETCH_POSTING_FAILED:
      state.posting = {};
      state.loading = 'error';
      return { ...state };
    default:
      return { ...state };
  }
};

export default PostingFilteredReducer;
